<template>
  <div class="list-tab">
    <RadioButtons kind="lang" v-model="lang" mandatory/>
    <b-table @click="show" :data="list" :columns="columns" paginated hoverable :per-page="per_page" :current-page.sync="page" backend-pagination :total="total"/>
  </div>
</template>

<script>
import RadioButtons from '@/components/RadioButtons.vue'
import shared_data from '@/shared_data.js'

export default {
  name: 'ListTab',
  data: function() {
    return {
      lang : "ita",
      page: 1,
      per_page: 50,
      shdata: shared_data,
      columns: [
        {
            field: 'orig',
            label: 'Eredeti',
            width: '10em'
        },
        {
            field: 'hun',
            label: 'Fordítás',
        }
      ]
    }
  },
  computed: {
    list() {return this.$store.state.list},
    total() {return this.$store.state.total},
  },
  components: {
    RadioButtons
  },
  methods: {
    show: function(row) {
      this.$router.push('/show/' + row['id'])
    },
    load_dict: function() {
      this.$store.dispatch('fetchList', {'lang': this.lang, 'per_page': this.per_page, 'page': this.page})
    },
    set_tag: function() {
      document.cookie = 'llang='+this.lang+'; path=/';
      this.load_dict();
    }
  },
  watch: {
    lang: 'set_tag',
    page: 'load_dict'
  },
  mounted: function() {
    if (document.cookie != '') {
      var _d = {};
      for (const a of document.cookie.split(';')){
        var e = a.split('=');
        _d[e[0].trim()] = e[1].trim();
      }
      this.lang = _d['llang'];
    }
//    this.load_dict();
  }
}
</script>

<style scoped>
</style>
